/**
 * 停车场相关 API（百胜停车场对接）。创建于 2026-06-15
 */
import axios from "axios";
import { BaseApiUrl } from "./base";

const base = BaseApiUrl;

// ---- 配置 ----

/** 获取学校停车场配置 */
export function getParkingConfig(schoolId) {
  return axios.get(`${base}/api/ParkingFreeVehicle/GetConfig`, { params: { schoolId } });
}

/** 保存停车场配置 */
export function saveParkingConfig(schoolId, config) {
  return axios.post(`${base}/api/ParkingFreeVehicle/SaveConfig`, { schoolId, config });
}

/** 获取车牌录入与临时车业务配置 */
export function getParkingVehicleEntryConfig(schoolId) {
  return axios.get(`${base}/api/ParkingFreeVehicle/GetVehicleEntryConfig`, { params: { schoolId } });
}

/** 保存车牌录入与临时车业务配置 */
export function saveParkingVehicleEntryConfig(schoolId, config) {
  return axios.post(`${base}/api/ParkingFreeVehicle/SaveVehicleEntryConfig`, { schoolId, config });
}

/** 查询停车场管理员 */
export function getParkingAdminList(params) {
  return axios.get(`${base}/api/ParkingAdmin/GetList`, { params });
}

/** 新增停车场管理员 */
export function addParkingAdmin(data) {
  return axios.post(`${base}/api/ParkingAdmin/Add`, data);
}

/** 修改停车场管理员 */
export function editParkingAdmin(data) {
  return axios.post(`${base}/api/ParkingAdmin/Edit`, data);
}

/** 删除停车场管理员 */
export function deleteParkingAdmin(id) {
  return axios.post(`${base}/api/ParkingAdmin/Delete`, null, { params: { id } });
}

// ---- 停车场后台管理（登录鉴权，按学校操作，无需审批人 Id）。最后修改：2026-10-10 ----

/** 按主体聚合分页查询全校师生长期车牌（含汇总） */
export function getParkingManageVehiclePage(params) {
  return axios.get(`${base}/api/ParkingManage/GetVehiclePage`, { params });
}

/** 查询学生的监护人列表（录入家长车牌时选择监护人） */
export function getParkingStudentParents(params) {
  return axios.get(`${base}/api/ParkingManage/GetStudentParents`, { params });
}

/** 后台直改某个监护人或教师的整组车牌 */
export function saveParkingManageVehicles(data) {
  return axios.post(`${base}/api/ParkingManage/SaveVehicles`, data);
}

/** 分页查询车牌申请（家长/教师） */
export function getParkingPlateRequestPage(params) {
  return axios.get(`${base}/api/ParkingManage/GetPlateRequestPage`, { params });
}

/** 车牌申请汇总 */
export function getParkingPlateRequestSummary(schoolId) {
  return axios.get(`${base}/api/ParkingManage/GetPlateRequestSummary`, { params: { schoolId } });
}

/** 后台审批家长长期车牌 */
export function auditParkingParentPlate(data) {
  return axios.post(`${base}/api/ParkingManage/AuditParentPlate`, data);
}

/** 后台审批教师长期车牌 */
export function auditParkingTeacherPlate(data) {
  return axios.post(`${base}/api/ParkingManage/AuditTeacherPlate`, data);
}

/** 分页查询临时车申请 */
export function getParkingTempApplicationPage(params) {
  return axios.get(`${base}/api/ParkingManage/GetTempApplicationPage`, { params });
}

/** 临时车申请汇总 */
export function getParkingTempSummary(schoolId) {
  return axios.get(`${base}/api/ParkingManage/GetTempSummary`, { params: { schoolId } });
}

/** 后台审批临时车 */
export function auditParkingTempVehicle(data) {
  return axios.post(`${base}/api/ParkingManage/AuditTempVehicle`, data);
}

/** 后台创建外来临时车邀请 */
export function createParkingTempInvite(data) {
  return axios.post(`${base}/api/ParkingManage/CreateInvite`, data);
}

/** 分页查询本校访客邀请 */
export function getParkingTempInvitePage(params) {
  return axios.get(`${base}/api/ParkingManage/GetInvitePage`, { params });
}

/** 禁用访客邀请 */
export function disableParkingTempInvite(schoolId, inviteId) {
  return axios.post(`${base}/api/ParkingManage/DisableInvite`, null, { params: { schoolId, inviteId } });
}

/** 重新启用访客邀请 */
export function enableParkingTempInvite(schoolId, inviteId) {
  return axios.post(`${base}/api/ParkingManage/EnableInvite`, null, { params: { schoolId, inviteId } });
}

/** 删除未使用过的访客邀请 */
export function deleteParkingTempInvite(schoolId, inviteId) {
  return axios.post(`${base}/api/ParkingManage/DeleteInvite`, null, { params: { schoolId, inviteId } });
}

// ---- 免费车 CRUD ----

/** 分页查询免费车列表 */
export function getParkingFreeVehiclePage(params) {
  return axios.get(`${base}/api/ParkingFreeVehicle/GetPage`, { params });
}

/** 按筛选条件汇总免费车 */
export function getParkingFreeVehicleSummary(params) {
  return axios.get(`${base}/api/ParkingFreeVehicle/GetSummary`, { params });
}

/** 新增免费车 */
export function addParkingFreeVehicle(data) {
  return axios.post(`${base}/api/ParkingFreeVehicle/Add`, data);
}

/** 编辑免费车 */
export function editParkingFreeVehicle(data) {
  return axios.post(`${base}/api/ParkingFreeVehicle/Edit`, data);
}

/** 删除免费车 */
export function deleteParkingFreeVehicle(id) {
  return axios.post(`${base}/api/ParkingFreeVehicle/Delete`, null, { params: { id } });
}

/** 按勾选 ID 批量删除免费车 */
export function deleteParkingFreeVehicleByIds(schoolId, ids) {
  return axios.post(`${base}/api/ParkingFreeVehicle/DeleteByIds`, { schoolId, ids });
}

/** 手动重试单条下发 */
export function retrySyncParkingVehicle(id) {
  return axios.post(`${base}/api/ParkingFreeVehicle/RetrySync`, null, { params: { id } });
}

/** 批量重试所有失败记录 */
export function retrySyncFailedBatch(schoolId) {
  return axios.post(`${base}/api/ParkingFreeVehicle/RetrySyncFailedBatch`, null, { params: { schoolId } });
}

/** 按勾选 ID 批量同步 */
export function syncByIds(schoolId, ids) {
  return axios.post(`${base}/api/ParkingFreeVehicle/SyncByIds`, { schoolId, ids });
}

// ---- Excel 导入/导出 ----

/** 下载导入模板 */
export function downloadParkingImportTemplate() {
  return `${base}/api/ParkingFreeVehicle/DownloadImportTemplate`;
}

/** 导出免费车列表 */
export function exportParkingFreeVehicle(schoolId) {
  return axios.get(`${base}/api/ParkingFreeVehicle/Export`, {
    params: { schoolId },
    responseType: 'blob',
  });
}

/** 预览 Excel 导入内容（不入库，返回行数据+重复标记） */
export function previewImportParkingFreeVehicle(schoolId, file) {
  const formData = new FormData();
  formData.append("schoolId", schoolId);
  formData.append("file", file);
  return axios.post(`${base}/api/ParkingFreeVehicle/PreviewImport`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

/** 根据预览确认后的行数据执行导入（JSON，不重新解析文件） */
export function importFromPreview(schoolId, rows, options = {}) {
  return axios.post(`${base}/api/ParkingFreeVehicle/ImportFromPreview`, { schoolId, rows }, {
    timeout: options.timeout || 600000,
    skipGlobalHttpErrorToast: options.skipGlobalHttpErrorToast
  });
}

/** 分批导入预览数据，避免大批量单次请求超时 */
export async function importFromPreviewBatched(schoolId, rows, onProgress) {
  const batchSize = 50;
  const aggregate = { successCount: 0, skipCount: 0, syncFailCount: 0, errors: [] };
  const total = rows.length;
  for (let i = 0; i < total; i += batchSize) {
    const batch = rows.slice(i, i + batchSize);
    const done = Math.min(i + batch.length, total);
    if (typeof onProgress === 'function') onProgress(done, total);
    const res = await importFromPreview(schoolId, batch, { skipGlobalHttpErrorToast: true });
    if (!res.data || !res.data.success) {
      throw new Error((res.data && res.data.msg) || '导入失败');
    }
    const r = res.data.response || {};
    aggregate.successCount += r.SuccessCount != null ? r.SuccessCount : (r.successCount || 0);
    aggregate.skipCount += r.SkipCount != null ? r.SkipCount : (r.skipCount || 0);
    aggregate.syncFailCount += r.SyncFailCount != null ? r.SyncFailCount : (r.syncFailCount || 0);
    const rawErrors = r.Errors || r.errors || [];
    aggregate.errors.push(...rawErrors.map(e => ({
      rowNumber: e.RowNumber !== undefined ? e.RowNumber : e.rowNumber,
      message: e.Message || e.message || ''
    })));
  }
  return aggregate;
}

/** 上传 Excel 导入免费车 */
export function importParkingFreeVehicle(schoolId, file) {
  const formData = new FormData();
  formData.append("schoolId", schoolId);
  formData.append("file", file);
  return axios.post(`${base}/api/ParkingFreeVehicle/Import`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// ---- 从监护人车牌导入 ----

/** 预览监护人车牌列表（分页） */
export function previewParentVehicles(params) {
  return axios.get(`${base}/api/ParkingFreeVehicle/PreviewParentVehicles`, { params });
}

/** 确认从监护人车牌导入 */
export function importFromParentVehicles(schoolId, items) {
  return axios.post(`${base}/api/ParkingFreeVehicle/ImportFromParentVehicles`, { schoolId, items });
}

// ---- 从教师车牌导入 ----

/** 预览教师车牌列表（分页） */
export function previewTeacherVehicles(params) {
  return axios.get(`${base}/api/ParkingFreeVehicle/PreviewTeacherVehicles`, { params });
}

/** 确认从教师车牌导入 */
export function importFromTeacherVehicles(schoolId, items) {
  return axios.post(`${base}/api/ParkingFreeVehicle/ImportFromTeacherVehicles`, { schoolId, items });
}

/** 分页查询免费车百胜下发同步日志 */
export function getParkingSyncLogPage(params) {
  return axios.get(`${base}/api/ParkingFreeVehicle/GetSyncLogPage`, { params });
}

/** 获取单条同步日志详情（含百胜响应） */
export function getParkingSyncLogDetail(id, schoolId) {
  return axios.get(`${base}/api/ParkingFreeVehicle/GetSyncLogDetail`, {
    params: { id, schoolId }
  });
}

/** 导出当前筛选条件的百胜下发同步日志 Excel */
export function exportParkingSyncLog(params) {
  return axios.get(`${base}/api/ParkingFreeVehicle/ExportSyncLog`, {
    params,
    responseType: "blob"
  });
}

/** 分页查询批量下发任务 */
export function getParkingBatchSyncJobPage(params) {
  return axios.get(`${base}/api/ParkingFreeVehicle/GetBatchSyncJobPage`, { params });
}

/** 分页查询批量下发任务明细 */
export function getParkingBatchSyncJobItemPage(params) {
  return axios.get(`${base}/api/ParkingFreeVehicle/GetBatchSyncJobItemPage`, { params });
}

/** 查询进行中的批量下发任务 */
export function getParkingBatchSyncJobRunning(schoolId) {
  return axios.get(`${base}/api/ParkingFreeVehicle/GetBatchSyncJobRunning`, {
    params: { schoolId }
  });
}

// ---- 进出记录 ----

/** 分页查询进出记录 */
export function getParkingAccessRecordPage(params) {
  return axios.get(`${base}/api/ParkingAccessRecord/GetPage`, { params });
}

/** 按筛选条件汇总进出记录 */
export function getParkingAccessRecordSummary(params) {
  return axios.get(`${base}/api/ParkingAccessRecord/GetSummary`, { params });
}

/** 导出进出记录 Excel（按当前筛选条件全量导出） */
export function exportParkingAccessRecord(params) {
  return axios.get(`${base}/api/ParkingAccessRecord/Export`, {
    params,
    responseType: 'blob',
  });
}

/** 进出记录详情 */
export function getParkingAccessRecordDetail(params) {
  return axios.get(`${base}/api/ParkingAccessRecord/GetDetail`, { params });
}

/** 预览仍含厂家域名（ist-falcon）抓拍图的进出记录 */
export function getParkingExternalPicPending(params) {
  return axios.get(`${base}/api/ParkingAccessRecord/GetExternalPicPending`, { params });
}

/** 将厂家抓拍图转存本校 OSS */
export function migrateParkingExternalPics(data) {
  return axios.post(`${base}/api/ParkingAccessRecord/MigrateExternalPics`, data, {
    timeout: 10 * 60 * 1000,
  });
}
